const initialState = {
  datos: {},
  loading: false,
  error: null,
  status: 200,
  statusFail: null,
  item: {
    datos: {},
    loading: false,
    error: null,
    status: null
  },
  items: {
    loading: false,
    error: null,
    status: null,
    datos: [],
    hasitem: []
    //statusFail: null
  },
  editedItem: {
    loading: false,
    erorr: null,
    result: false,
    status: null
  },
  delete: {
    loading: false,
    error: null,
    datos: {}
  },
  lists: {
    error: null,
    datos: [],
    loading: false,
    status: null
  },
  deletedItem: {
    error: null,
    status: null,
    result: false
  }
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/dynamic_list/initialState.js